import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import BreedServices from '../components/BreedServices';
import BreadCumbcat from '../components/catlists/BreadCumb';
import Faq from '../components/Faq';
import ShopAreaCat from '../components/ourshop/ShopAreaCat';
import NewArrivals from '../components/NewArrivals ';


function CatList() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);


	return (

		<main>
						 <Helmet>
        <title>Chats - Animalia</title>
        <meta name="description" content="Découvrez notre sélection de nos produits pour chats chez Animalia." />
      </Helmet>

			<BreadCumbcat/>
			<ShopAreaCat />
<div style={{ marginTop: "-100px" }}>
  <NewArrivals />
</div>
			{/* <Faq afterElment="faq-area-two" />
			<BreedServices /> */}
			{/* <NewsLetter /> */}

		</main>
	)
}

export default CatList;
